import { useState } from "react";

const buttons = [
  {
    href: "tel:+905321367981",
    icon: "ri-phone-line",
    label: "Telefon",
    color: "hover:bg-[#1A2B4A]",
    iconColor: "text-[#1A2B4A]",
  },
  {
    href: "https://wa.me/905321367981",
    icon: "ri-whatsapp-line",
    label: "WhatsApp",
    color: "hover:bg-[#25D366]",
    iconColor: "text-[#25D366]",
    external: true,
  },
  {
    href: "https://www.instagram.com/guvenlidizayn/",
    icon: "ri-instagram-line",
    label: "Instagram",
    color: "hover:bg-[#E1306C]",
    iconColor: "text-[#E1306C]",
    external: true,
  },
  {
    href: "https://www.linkedin.com/company/g%C3%BCvenli-dizayn",
    icon: "ri-linkedin-line",
    label: "LinkedIn",
    color: "hover:bg-[#0077B5]",
    iconColor: "text-[#0077B5]",
    external: true,
  },
];

export default function FloatingSocial() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Desktop — sabit sağ orta */}
      <div className="hidden md:flex fixed right-5 top-1/2 -translate-y-1/2 z-40 flex-col gap-3">
        {buttons.map((btn) => (
          <a
            key={btn.label}
            href={btn.href}
            target={btn.external ? "_blank" : undefined}
            rel={btn.external ? "noopener noreferrer" : undefined}
            aria-label={btn.label}
            className={`w-11 h-11 flex items-center justify-center bg-white rounded-full shadow-md hover:scale-110 ${btn.color} hover:text-white transition-all duration-200 cursor-pointer group`}
          >
            <i className={`${btn.icon} text-xl ${btn.iconColor} group-hover:text-white`} />
          </a>
        ))}
      </div>

      {/* Mobil — alt butonlar (ana butonun üzerinde açılır) */}
      <div className="md:hidden fixed bottom-24 right-5 z-40 flex flex-col-reverse gap-3 items-center">
        {buttons.map((btn, i) => (
          <a
            key={btn.label}
            href={btn.href}
            target={btn.external ? "_blank" : undefined}
            rel={btn.external ? "noopener noreferrer" : undefined}
            aria-label={btn.label}
            onClick={() => setOpen(false)}
            className={`w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg ${btn.color} hover:text-white transition-all duration-300 cursor-pointer group ${
              open
                ? "opacity-100 translate-y-0 pointer-events-auto"
                : "opacity-0 translate-y-4 pointer-events-none"
            }`}
            style={{ transitionDelay: open ? `${i * 50}ms` : "0ms" }}
          >
            <i className={`${btn.icon} text-xl ${btn.iconColor} group-hover:text-white`} />
          </a>
        ))}
      </div>

      {/* Mobil — ana buton (sabit sağ alt) */}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="İletişim"
        className={`md:hidden fixed bottom-6 right-5 z-40 w-14 h-14 flex items-center justify-center rounded-full shadow-xl transition-all duration-300 cursor-pointer ${
          open ? "bg-[#1A2B4A] rotate-45" : "bg-[#4CAF50]"
        }`}
      >
        <i className={`text-white text-2xl ${open ? "ri-close-line" : "ri-share-line"}`} />
      </button>

      {/* Arka plan overlay — mobil */}
      {open && (
        <div
          className="md:hidden fixed inset-0 z-30"
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
}
